import {
  GET_CLIENT_DATA,
  GET_CLIENT_LOADING,
  GET_PRIVACY_POLICY_DATA,
  GET_PRIVACY_POLICY_LOADING,
  GET_SOCIAL_MEDIA_DATA,
  GET_SOCIAL_MEDIA_LOADING,
  GET_TERMS_AND_CONDITION_DATA,
  GET_TERMS_AND_CONDITION_LOADING,
} from './client.types';

const INITIAL_STATE = {
  payload: null,
  error: null,
  isLoading: true,
  social_media: {
    payload: null,
    error: null,
    isLoading: true,
  },
  privacy_policy: {
    payload: null,
    error: null,
    isLoading: true,
  },
  terms_and_condition: {
    payload: null,
    error: null,
    isLoading: true,
  },
};

const clientReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CLIENT_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_CLIENT_DATA:
      return {
        ...state,
        payload: action.payload,
        error: action.error,
        isLoading: false,
      };
    case GET_SOCIAL_MEDIA_LOADING:
      return {
        ...state,
        social_media: {
          ...state.social_media,
          isLoading: true,
        },
      };
    case GET_SOCIAL_MEDIA_DATA:
      return {
        ...state,
        social_media: {
          ...state.social_media,
          payload: action.payload,
          error: action.error,
          isLoading: false,
        },
      };
    case GET_PRIVACY_POLICY_LOADING:
      return {
        ...state,
        privacy_policy: {
          ...state.privacy_policy,
          isLoading: true,
        },
      };
    case GET_PRIVACY_POLICY_DATA:
      return {
        ...state,
        privacy_policy: {
          ...state.privacy_policy,
          payload: action.payload,
          error: action.error,
          isLoading: false,
        },
      };
    case GET_TERMS_AND_CONDITION_LOADING:
      return {
        ...state,
        terms_and_condition: {
          ...state.terms_and_condition,
          isLoading: true,
        },
      };
    case GET_TERMS_AND_CONDITION_DATA:
      return {
        ...state,
        terms_and_condition: {
          ...state.terms_and_condition,
          payload: action.payload,
          error: action.error,
          isLoading: false,
        },
      };
    default:
      return state;
  }
};

export default clientReducer;
